import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc72c146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-header" }, [
  /*#__PURE__*/_createTextVNode(" My Cart "),
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "panels"
}
const _hoisted_4 = { class: "items-panel" }
const _hoisted_5 = { class: "summary-panel" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Your cart is empty. Check our available products", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_CartPanel = _resolveComponent("CartPanel")!
  const _component_SummaryInfo = _resolveComponent("SummaryInfo")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.orderedItems.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_CartPanel, {
                onDeleteItem: _ctx.deleteItem,
                onEditDesign: _ctx.editDesign,
                onQuantityChanged: _ctx.changeQuantity
              }, null, 8, ["onDeleteItem", "onEditDesign", "onQuantityChanged"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SummaryInfo)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Button, {
              label: "View products",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'home' })))
            })
          ]))
    ])
  ], 64))
}